import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-text";

import { useGoogleFreeBookingLinksSettingsI18nContext } from "../../../_context";

export const FormHotelName = () => {
	const { form } = useGoogleFreeBookingLinksSettingsI18nContext();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<QuestionForMain
			title={"ホテル名"}
			required
			inputChildren={
				<InputTextFieldRHF
					label="ホテル名"
					errorMessage={errors?.hotelName?.message}
					{...register("hotelName")}
				/>
			}
		/>
	);
};
